module.exports = __webpack_public_path__ + "img/icon-lock-blue-quest-dark.743e5746.svg";